import React from 'react';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, LineSeries, DateTime, Legend, Tooltip, DataLabel } from '@syncfusion/ej2-react-charts';

import { lineCustomSeriesEDAreviewTrend, LinePrimaryXAxis, 
          LinePrimaryYAxisReview, lineCustomSeriesSentimentTrend } from '../../data/dummy';
import { useStateContext } from '../../contexts/ContextProvider';

const LineChartEDAreviewTrend = () => {
  const { currentMode } = useStateContext();
  const LinePrimaryXAxis = {
    valueType: 'DateTime',
    intervalType: 'Months',
    labelFormat: "yy년 M월", // 사용자 정의 형식
    edgeLabelPlacement: 'Shift',
    majorGridLines: { width: 0 },
  };

  // 데이터 레이블 렌더링
  const onTextRender = (args) => {
    const lastPointIndex = args.series.points.length - 1;
    if (args.point.index === lastPointIndex) {
      args.text = args.text; // 텍스트 유지
      args.location.x -= 20; // X축 위치 왼쪽으로 이동
    }
  };

  return (

    <ChartComponent
      id="line-chart-review"
      height="420px"
      primaryXAxis={LinePrimaryXAxis}
      primaryYAxis={LinePrimaryYAxisReview}
      chartArea={{ border: { width: 0 } }}
      tooltip={{ enable: true }}
      background={currentMode === 'Dark' ? '#33373E' : '#fff'}
      legendSettings={{ background: 'white' }}
      // margin={{ right: 50 }} // 오른쪽 마진 추가
      textRender={onTextRender} // 데이터 레이블 텍스트 위치 조정

    >
      <Inject services={[LineSeries, DateTime, Legend, Tooltip, DataLabel]} />
      <SeriesCollectionDirective>
      {lineCustomSeriesEDAreviewTrend.map((item, index) => (
          <SeriesDirective
            key={index}
            {...item}
            marker={{
              visible: true,
              dataLabel: {
                visible: true,
                position: 'Outer', // 기본적으로 외부에 표시
                font: { size: '14px', color: currentMode === 'gray' ? 'gray' : 'gray' },
              },
            }}
          />
        ))}
      </SeriesCollectionDirective>
    </ChartComponent>
  );
};

export default LineChartEDAreviewTrend;
